import React from 'react';
import styled from 'styled-components';
import {Edit} from '@styled-icons/material/Edit';
import {Check} from '@styled-icons/material/Check';
import {CloudUpload} from '@styled-icons/material/CloudUpload';
import * as UploadUtil from '../../Utils/UploadUtil';

export default function AdminAvatarWidget(props) {
  const {value = '', onChange, rawErrors, ...extra} = props;
  const [photoObjUrl, setPhotoObjUrl] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);

  //rjsf write "readOnly", but props get "readonly".
  const readonly = props.readonly === true || props.readOnly === true;

  const error = Array.isArray(rawErrors) ? rawErrors[0] : undefined;

  const upload = React.useCallback(async (file) => {
    setLoading(true);
    setSuccess(false);

    try {
      const url = await UploadUtil.uploadFile(file, 'photo/' + file.name);
      onChange(url);
      setSuccess(true);
    } catch (e) {
      console.error('upload file error', e);
    }
    setLoading(false);
  }, []);

  return (
    <Wrapper className="admin-avatar-widget" id={extra.id}>
      <label className={'' + (error ? ' error' : '')}>
        {value ? (
          <img src={value} alt="selected file" />
        ) : (
          <img src="/images/character-2.png" alt="default-avatar" />
        )}
        <div className="edit-icon">
          {loading ? (
            <CloudUpload color="white" size={20} />
          ) : success ? (
            <Check color="white" size={20} />
          ) : (
            <Edit color="white" size={20} />
          )}
        </div>

        <input
          type="file"
          accept="image/*"
          disabled={readonly}
          onChange={(e) => {
            const f = e.target.files[0];

            if (f) {
              // onChange(f);
              // setPhotoObjUrl(URL.createObjectURL(f));
              upload(f);
            } else {
              onChange('');
              // setPhotoObjUrl(null);
            }
          }}
        />
      </label>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  label {
    width: 150px;
    height: 150px;
    background-color: var(--primaryLightColor);
    border-radius: 75px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    cursor: pointer;

    & > .edit-icon {
      background-color: var(--primaryColor);
      width: 30px;
      height: 30px;
      border-radius: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 5px;
      bottom: 5px;
    }
  }
  label.error {
    border-color: var(--ant-error-color);
  }
  input[type='file'] {
    display: none;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    overflow: hidden;
    border-radius: 50%;
  }
`;
